import { render, staticRenderFns } from "./QualityAssuranceItemsMntIssues.vue?vue&type=template&id=48580bf1&"
import script from "./QualityAssuranceItemsMntIssues.vue?vue&type=script&lang=js&"
export * from "./QualityAssuranceItemsMntIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports